import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/sysPrtLists/load',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/sysPrtLists/add',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/sysPrtLists/update',
    method: 'post',
    data
  })
}

export function del(data) {
  return request({
    url: '/sysPrtLists/delete',
    method: 'post',
    data
  })
}

